import {Project} from "../../../../api/Projects";
import {DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {api} from "../../../../api/API";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useState} from "react";
import {AutoComplete} from "../../shopdrawing/openings/AutoComplete";
import {User} from "../../../../api/Users";

export function UsrEdit(props: {
    value: Project;
    onDone(): void;
}) {

    const onDoneRef = useSyncedRef(props.onDone);
    const update = useAsyncAction(async input => {
        await api.projects.upsert(input)
        onDoneRef.current();
    }, [])

    const [contact, setContact] = useState<User|null>(props.value.pmContact ? {
        id: props.value.pmContact,
        name: props.value.pmContactName,
    } as User : null);

    const submit = () => {
        update.callback(Object.assign({}, props.value, {
            projectManager: contact?.id || null,
        }));
    };

    return (
        <Dialog2 open onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>Choose Project Manager</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />

                <AutoComplete<User>
                    label="Find Person"
                    search={async input => {
                        const result = await api.users.list({
                            search: input,
                            offset: 0,
                            permission: "ProjectManager",
                        })

                        return result.data;
                    }}
                      value={contact}
                      equals={(a, b) => a.id === b.id}
                      makeLabel={a => a.name}
                      onSelect={setContact}
                />

            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                onCancel={props.onDone}
                onSubmit={submit}
            />
        </Dialog2>
    )
}